// Anchor link handling
export function handleAnchor(hash) {
  // Prevent default auto-scrolling behavior only if the hash refers to an element on the same page
  if (!hash || hash === '#') {
    return;
  }
  const targetElement = document.querySelector(hash);
  if (targetElement) {
    // Calculate the position of the element with an offset
    const offset = 100; // Adjust this value as needed
    const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;

    // Manually scroll to the target element with the offset
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    });
    // Update the hash in the URL without auto-scrolling
    history.replaceState(null, null, hash);
  }
}

//Add target blank for external links
export function targetAnchor() {
  const externalLinks = document.querySelectorAll('a:not([href^="' + empower_options.siteUrl + '"]):not([href^="/"]):not([href^="mailto"]):not([href^="#"])');
  externalLinks.forEach(link => {
    link.setAttribute('target', '_blank');
  });
}
